import React, {FunctionComponent} from "react";

const styles = require('./articleView.component.scss');

interface ArticleViewProps {
    articleTitle: string,
    articleDescription: string,
    date?: string,
    selected?: boolean,
    animation?: boolean
}

export const ArticleView: FunctionComponent<ArticleViewProps> = ({articleTitle, articleDescription, selected = false, animation, date}) => {

    return (
        <>
            <div className={styles.container}>
                <div className={`${styles.containerText}`}>
                    <div className={`${styles.articleViewTitle} `}>
                        <div dangerouslySetInnerHTML={{__html: articleTitle}}/>
                    </div>
                    <div className={`${styles.articleViewDescription} `}>
                        <div dangerouslySetInnerHTML={{__html: articleDescription}}/>
                    </div>
                    <div className={styles.date}>
                        {date}
                    </div>
                </div>
                {animation &&
                <div className={styles.gotToArticleCont}>
                    <div className={styles.gotToArticleSmall}>
                        <div className={styles.goToIcon}>
                            <i className='fa fa-arrow-right'/>
                        </div>
                    </div>
                </div>
                }
            </div>
        </>
    )
}
